import React from "react";
import moment from "moment";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as foldersReducer from "containers/Folders/reducer";

import { getProjectID, getProjectDatasets, getCreatingProject } from "containers/ConsultingProjects/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { getIsDataLink } from "containers/SchemaMonitor/reducer";

import DatasetItem from "containers/View/Item/DatasetItem";
import RecipeItem from "containers/View/Item/RecipeItem";

import EmptyTile from "components/Tiles/EmptyTile";
import EmptyNotice from "components/View/EmptyNotice";
import UploadModal from "components/View/UploadModal";

import SubView from "components/View/SubView";
import ViewMessage from "components/View/ViewMessage";

import DatasetTile from "components/Tiles/DatasetTile";
import * as schemaMonitorReducer from "containers/SchemaMonitor/reducer";

import { isEnabled } from "utils/featureFlags";
import * as paginationReducer from "containers/Pagination/reducer";

class DatasetViewContainer extends React.Component {
  state = {
    showUploadModal: false,
    isLinkMode: false,
    uploadUrl: undefined
  };
  setModal(value = false) {
    return this.setState({
      showUploadModal: value,
      uploadUrl: undefined,
      shellDatasetName: undefined,
      shellDatasetDescription: undefined
    });
  }

  handleFile(event) {
    const { handleFileChange, validateFileExtension } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      this.setModal(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  createShellDataset(name) {
    const { handleFileChange } = this.props;

    // create dummy file - not actually uploaded
    const blob = new Blob(["1"], { type: "text/plain" });
    const file = new File([blob], name, { type: blob.type });

    this.setState({ uploadUrl: "Creating..." });

    return handleFileChange(
      file,
      {},
      {
        skipUpload: true,
        description: this.state.shellDatasetDescription
      }
    ).then((dataset) => this.setState({ uploadUrl: dataset.metadata.upload_url }));
  }

  handleImportRecipeTrigger() {
    const { importRecipeId, executeRecipeImport, linkBlueprintToRecipeVersionInstance } = this.props;
    this.setState({
      isImportRecipeCreating: true
    });

    executeRecipeImport(importRecipeId, () => {
      this.setState({ isImportRecipeCreating: false });
    }).then((recipeVersionInstance) => linkBlueprintToRecipeVersionInstance(recipeVersionInstance.id));
  }

  isImportRecipeExecuting() {
    return (this.state && this.state.isImportRecipeCreating) || this.props.isImportRecipeExecuting;
  }

  renderFirstTile() {
    const {
      tableauData,
      importRecipeId,
      importVendor,
      handleTableauUpload,
      isTabUploading,
      isDataUploading,
      updateIsLinkMode,
      updateIsBoomiLinkMode,
      linkDataset,
      updateStep,
      history,
      blueprintId,
      hideFirstTile,
      useUploadModal,
      folderEditPermission,
      userInfoQuery
    } = this.props;

    if (hideFirstTile) {
      return <EmptyTile />;
    }

    return (
      <React.Fragment>
        {tableauData && folderEditPermission ? (
          <DatasetTile
            isTableau={true}
            onClick={() => handleTableauUpload()}
            isTabUploading={isTabUploading}
            userInfoQuery={userInfoQuery}
          />
        ) : (
          false
        )}
        {importRecipeId && folderEditPermission ? (
          <RecipeItem
            id={importRecipeId}
            onClick={() => this.handleImportRecipeTrigger(importRecipeId)}
            isTrayUploading={this.isImportRecipeExecuting()}
          />
        ) : (
          false
        )}
        <DatasetTile
          isCreate
          isCreateDisabled={!folderEditPermission}
          id={"uploader"}
          isDataUploading={isDataUploading}
          onClick={useUploadModal ? () => this.setModal(true) : () => document.getElementById("fUpload").click()}
          userInfoQuery={userInfoQuery}
        />
        {getIsDataLink() ? (
          <DatasetTile
            isLink
            linkType={"BOOMI"}
            id={"linker"}
            isCreateDisabled={!folderEditPermission}
            isDataUploading={false}
            updateIsBoomiLinkMode={(isLinkMode) => updateIsBoomiLinkMode(isLinkMode)}
            onClick={(settings) => linkDataset(settings)}
            userInfoQuery={userInfoQuery}
          />
        ) : (
          ""
        )}
        {getIsDataLink() ? (
          <DatasetTile
            isLink
            id={"linker"}
            isCreateDisabled={!folderEditPermission}
            isDataUploading={false}
            updateIsLinkMode={(isLinkMode) => updateIsLinkMode(isLinkMode)}
            onClick={(settings) => linkDataset(settings)}
            userInfoQuery={userInfoQuery}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }

  renderFirstRow() {
    const {
      tableauData,
      importRecipeId,
      isTabUploading,
      isDataUploading,
      handleTableauUpload,
      updateStep,
      history,
      blueprintId,
      hideFirstTile,
      useUploadModal,
      folderEditPermission,
      isChatStyle
    } = this.props;

    if (isChatStyle) {
      return <React.Fragment />;
    }

    return (
      <div>
        {!hideFirstTile && tableauData && folderEditPermission && (
          <Button type="secondary" onClick={() => handleTableauUpload()} disabled={isTabUploading}>
            {"Import From Tableau"}
          </Button>
        )}
        {!hideFirstTile && importRecipeId && folderEditPermission && (
          <Button
            type="secondary"
            onClick={() => this.handleImportRecipeTrigger(importRecipeId)}
            disabled={this.isImportRecipeExecuting()}
          >
            {"Import From Tray.io"}
          </Button>
        )}
        {!hideFirstTile && folderEditPermission && (
          <Button
            type="secondary"
            disabled={isDataUploading}
            onClick={useUploadModal ? () => this.setModal(true) : () => document.getElementById("fUpload").click()}
          >
            {"Import CSV"}
          </Button>
        )}
      </div>
    );
  }

  getHeaders() {
    return ["Dataset", "Creation", "Outcome", "Columns", "Rows", "Status", "Warnings"];
  }

  getIsCategorical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "categorical"
    );
  }

  getIsNumerical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "number"
    );
  }

  render() {
    const {
      onClick,
      isTile,
      blueprintId,
      fetchNext,
      isDatasetsLoading,
      tableauData,
      isConsumer,
      hDatasetId,
      data,
      isModal,
      isLinkMode,
      selectedAccountId,
      hideDelete,
      isCategorical,
      isNumerical,
      search,
      isChatStyle,
      hideShowMoreDatasets
    } = this.props;

    const { showUploadModal } = this.state;

    const filteredData = isCategorical
      ? data.filter((d) => this.getIsCategorical(d))
      : isNumerical
        ? data.filter((d) => this.getIsNumerical(d))
        : data;

    const retData = isConsumer ? filteredData.filter((d) => d.id !== hDatasetId) : filteredData;

    if (isConsumer && !isDatasetsLoading && !(retData && retData.length)) {
      return (
        <EmptyNotice
          title={"No Datasets Available"}
          body={
            "You don't have access to any datasets right now. You will see datasets once someone shares a dataset with you."
          }
        />
      );
    }

    return (
      <React.Fragment>
        <SubView
          {...this.props}
          label="Datasets"
          headers={this.getHeaders()}
          firstTile={isChatStyle || isModal || isEnabled("aible-consumer") ? "" : this.renderFirstTile()}
          firstRow={this.renderFirstRow()}
          emptyMessage={
            getIsEDG() ? (
              <ViewMessage title={"Add Data to Begin"}>
                {"Your folder does not have any data. Click the Link to Data Source button to start " +
                  "securly cataloging and evaluating your data with the the Aible Enterprise Data gallery"}
              </ViewMessage>
            ) : undefined
          }
          length={retData.length}
          fetchNext={() => fetchNext()}
          isLoading={isDatasetsLoading}
          isInfinite={true}
          hideShowMore={isChatStyle || hideShowMoreDatasets ? true : false}
          renderTile={(columnIndex, style) =>
            retData && retData.length > columnIndex ? (
              <DatasetItem
                isChatStyle={isChatStyle}
                id={retData[columnIndex].id}
                data={retData[columnIndex]}
                key={columnIndex}
                style={style}
                blueprintId={blueprintId}
                onClick={onClick}
                index={columnIndex}
                hideDelete={hideDelete}
                isConsumer={isConsumer}
                shouldHighlight={
                  hDatasetId === retData[columnIndex].id ? true : hDatasetId !== undefined ? false : undefined
                }
              />
            ) : undefined
          }
          childrenLength={retData.length}
        />
        <div style={{ display: "none" }}>
          <input type="file" ref="file" id="fUpload" onChange={(e) => this.handleFile(e)} />
        </div>
        <UploadModal
          show={showUploadModal}
          selectedAccountId={selectedAccountId}
          handleClose={() => this.setModal(false)}
          handleUpload={() => document.getElementById("fUpload").click()}
          uploadUrl={this.state.uploadUrl}
          handleCreateShellDataset={() => this.createShellDataset(this.state.shellDatasetName)}
          shellDatasetName={this.state.shellDatasetName}
          updateShellDatasetName={(x) => this.setState({ shellDatasetName: x })}
          shellDatasetDescription={this.state.shellDatasetDescription}
          updateShellDatasetDescription={(x) => this.setState({ shellDatasetDescription: x })}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  handleFileChange: (file, target, additionalOptions) =>
    dispatch(uploadReducer.handleFileChange(file, target, additionalOptions)),

  handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),
  executeRecipeImport: (recipeId, onComplete) => dispatch(recipeReducer.executeRecipeImport(recipeId, onComplete)),

  fetchNext: () => dispatch(homeReducer.fetchNextDatasets(undefined, undefined, undefined, undefined, true)),
  fetchAll: () => dispatch(homeReducer.fetchNextDatasets(true)),
  linkBlueprintToRecipeVersionInstance: (recipeVersionInstanceId) =>
    dispatch(recipeReducer.linkBlueprintToRecipeVersionInstance(ownProps.blueprintId, recipeVersionInstanceId)),

  updateIsLinkMode: (show) => dispatch(schemaMonitorReducer.updateIsShowModal(show)),
  updateIsBoomiLinkMode: (show) => dispatch(viewReducer.updateIsBoomiLinkMode(show)),
  linkDataset: (settings) => dispatch(homeReducer.linkDataset(settings))
});

const mapStateToProps = (state, ownProps) => {
  const importRecipeId = blueprintReducer.getImportRecipeId(state, ownProps.blueprintId);

  const accounts = accountsReducer.getAccounts(state);
  const selectedFolder = foldersReducer.getSelectedFolder(state);

  return {
    isTile: viewReducer.getIsTile(state),
    data:
      (getIsMarketplaceDemo() &&
        getProjectID(state) !== null &&
        getCreatingProject(state) &&
        getProjectDatasets(state)) ||
      viewReducer.getDatasets(state, ownProps.blueprintId),
    type: ownProps.type ? ownProps.type : viewReducer.getType(state),

    tableauData: loginReducer.getTableauDataOptions(state),
    importRecipeId: blueprintReducer.getImportRecipeId(state, ownProps.blueprintId),
    importVendor: recipeReducer.getImportVendor(state, importRecipeId),
    isImportRecipeExecuting:
      recipeReducer.getRecipeVersionInstanceStatusByBlueprintId(state, ownProps.blueprintId) ==
      recipeReducer.RecipeVersionInstanceStatus.Running,
    isTabUploading: loginReducer.getIsTabUploading(state),
    isDataUploading: globalReducer.getIsDataUploading(state),
    isDatasetsLoading: globalReducer.getIsDatasetsLoading(state),
    useUploadModal: isEnabled("dataset-upload") || (accounts && accounts.length > 1),
    selectedAccountId: accountsReducer.getSelectedAccountId(state),
    account: accountsReducer.getSelectedAccount(state),
    folderEditPermission: foldersReducer.getUserEditPermission(state, selectedFolder),
    folder: foldersReducer.getSelectedFolderData(state),
    tenant: loginReducer.getSelectedTenant(state),
    isLinkMode: schemaMonitorReducer.getIsShowModal(state),

    search: viewReducer.getSearch(state),
    userInfoQuery: loginReducer.createUserInfoQuery(state),

    hideShowMoreDatasets: paginationReducer.getHideShowMoreDatasets(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetViewContainer);
